import React from "react";
import { Calculator } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

// v0.6.8 — Steps 4/5/6 each require an already-run calculation, but
// `calc` lives only in this browser tab's sessionStorage-backed
// restore (see WorkflowContext.jsx's boot effect) — a fresh tab, a
// new browser window, or a cleared session lands here with no calc
// and every child on the step quietly renders nothing, one after
// another, leaving a blank page with no explanation (found live:
// operator opened the review link in a new tab and saw an empty
// screen with no indication why). This makes that state explicit.
export const NoActiveCalcNotice = ({ onGoToUpload }) => { const { t } = useTranslation(); return (
  <div
    data-testid="no-active-calc-notice"
    className="border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 rounded-xl p-8 flex flex-col items-center text-center gap-3"
  >
    <Calculator size={32} weight="duotone" className="text-slate-400 dark:text-slate-500" />
    <div className="font-semibold text-slate-700 dark:text-slate-200">
      {t("ui.no_active_calc.title", { defaultValue: "No active calculation" })}
    </div>
    <div className="text-sm text-slate-500 dark:text-slate-400 max-w-md">
      {t("ui.no_active_calc.body", { defaultValue: "This browser tab doesn't have a calculation loaded — that can happen in a fresh tab or after a while away. Start one from Upload, or reopen the specific calc's link if you have one." })}
    </div>
    <button
      type="button"
      data-testid="no-active-calc-goto-upload"
      onClick={() => onGoToUpload?.()}
      className="mt-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold text-xs px-4 py-2 rounded-xl"
    >
      {t("ui.no_active_calc.goto_upload", { defaultValue: "Go to Upload →" })}
    </button>
  </div>
); };

export default NoActiveCalcNotice;
